// main.js
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'    
import { createI18n } from 'vue-i18n'
import { messages } from './locales'

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@mdi/font/css/materialdesignicons.css'

const i18n = createI18n({
  legacy: false,
  locale: 'en', // język domyślny
  fallbackLocale: 'en',
  messages,
})

const vuetify = createVuetify({
  components,
  directives,
})

createApp(App).use(router).use(vuetify).use(i18n).mount('#app')